import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistasuperplasths1000Img from '@/assets/images/products/vistasuperplasths1000.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};


const VistaSuperplastHs1000 = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Superplast HS 1000"
        subTitle="(HIGH PERFORMANCE SUPER-PLASTICIZING ADMIXTURE)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          imageUrl={vistasuperplasths1000Img}
          title="Description"
          content="VISTA SUPERPLAST HS is a unique multipurpose advance technology high-performance Super-plasticizing Accelerating admixture based on modified poly carboxylate ether conforming to ASTM C494."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Improved Dispersion Properties.",
                "Very High Water Reduction.",
                "Improved Strength And Density.",
                "Improved Compactness.",
                "Improved Cohesiveness.",
              ],
              [
                "Acceleration Setting Time.",
                "Improved Flowability.",
                "Arrest Shrinkage.",
                "Improved Workability Retention.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area Of Application">
          <Paragraph content="VISTA SUPERPLAST HS is recommended for use in free-flowing concrete in piling, floors, slabs, foundations, precast concrete, concrete of vertical tower, walls, and columns, and other structural elements." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Light Brown Liquid"],
                ["Specific Gravity", "1.08 ± 0.02 @27°C"],
                ["Chloride Content", "0.2 % (MAX)"],
                ["pH", "> 6"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precaution">
          <Paragraph content="Health & Safety Instruction: Vista Superplast is non-toxic. Any splashes on the skin should be washed immediately with water." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperplastHs1000;
